import { render, staticRenderFns } from "./SafeDigProfessional.vue?vue&type=template&id=1a8aeccc&scoped=true"
import script from "./SafeDigProfessional.vue?vue&type=script&lang=js"
export * from "./SafeDigProfessional.vue?vue&type=script&lang=js"
import style0 from "./SafeDigProfessional.vue?vue&type=style&index=0&id=1a8aeccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8aeccc",
  null
  
)

export default component.exports